import { Map } from 'immutable';

export const LANGPT = 'lang/LANGPT';
export const LANGEN = 'lang/LANGEN';
export const LANGES = 'lang/LANGES';

export const langpt = () => {
  return dispatch => {
    dispatch({
      type: LANGPT
    });
  };
};

export const langen = () => {
  return dispatch => {
    dispatch({
      type: LANGEN
    });
  };
};

export const langes = () => {
  return dispatch => {
    dispatch({
      type: LANGES
    });
  };
};

const initialState = Map({ lang: 'pt' }).toJS();

export default function LangReducer(state = initialState, action) {
  switch (action.type) {
    case LANGPT:
      return {
        ...state,
        lang: 'pt'
      };
    case LANGEN:
      return {
        ...state,
        lang: 'en'
      };
    case LANGES:
      return {
        ...state,
        lang: 'es'
      };

    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/redux/lang.js